import React from "react";
import { Input } from "reactstrap";

function AmazonProductListingTabs({ tabs, activeTab, setActiveTab, search, setSearch, previewMode }) {
  const mainTabs = tabs.filter(tab => tab.key !== 'errors' && tab.key !== 'warnings');
  const statusTabs = tabs.filter(tab => tab.key === 'errors' || tab.key === 'warnings');

  return (
    <div className="w-100">
      
      <div className="d-flex justify-content-between align-items-start w-100">
        
        <div 
          className="brand-tabs d-flex align-items-center flex-wrap" 
          style={{ flex: 1, rowGap: "12px" }}
        >
          
          {mainTabs.map(function (tab) {
            const isActive = activeTab === tab.key;
            return (
              <div
                key={tab.key}
                className={`main-tabs ${isActive && !previewMode ? "active" : ""}`}
                onClick={() => {
                  if (!previewMode) setActiveTab(tab.key);
                }}
                style={{ 
                  cursor: previewMode ? "default" : "pointer",
                  backgroundColor: previewMode ? "#ffffff" : undefined,
                  color: previewMode ? "#888888" : undefined
                }}
              >
                {tab.label}
                <span className="tab-count"> ({tab.count})</span>
              </div>
            );
          })}

          {statusTabs.map(function (tab) {
            const isActive = activeTab === tab.key;
            return (
              <div
                key={tab.key}
                className={`main-tabs ${isActive && !previewMode ? "active" : ""}`}
                onClick={() => {
                  if (!previewMode) setActiveTab(tab.key);
                }}
                style={{ 
                  cursor: previewMode ? "default" : "pointer",
                  backgroundColor: previewMode ? "#ffffff" : undefined,
                  color: previewMode ? "#888888" : undefined 
                }}
              >
                {tab.label}
                <span className="tab-count"> ({tab.count})</span>
              </div>
            );
          })}

        </div>

        <div className="d-flex align-items-center justify-content-end ml-2" style={{ minWidth: "220px", height: "40px" }}>
          <Input
            type="text"
            placeholder="Search fields..."
            value={search}
            className="w-100 m-0" 
            onChange={function (e) { setSearch(e.target.value); }}
            disabled={previewMode} 
          />
        </div>
        
      </div>
      
    </div>
  );
}

export default AmazonProductListingTabs;